import { ActionType } from 'deox';
import { takeLatest, put } from 'redux-saga/effects';

import { API } from 'api';

import { processRequestError } from 'modules/errors';

import { login } from './actions';

function* loginSaga({ payload }: ActionType<typeof login.request>) {
  try {
    const { data } = yield API.login(payload);
    yield put(login.success(data));
  } catch (error) {
    yield put(processRequestError({ error, failAction: login.fail }));
  }
}

export function* watchUser() {
  yield takeLatest(login.request, loginSaga);
}
